import sendBasketReq from './helpers/basketFetch';

const shareButtonHandler = async (evt) => {
  evt.preventDefault();

  const formData = new FormData(evt.target);
  formData.append('sessid', window.localStorage.getItem('sessId'));
  const response = await sendBasketReq(formData);
  if (response) {
    // eslint-disable-next-line
    popupOpenUniversalForm('', 'Информация отправлена на указанный e-mail');
  } else {
    // eslint-disable-next-line
    popupOpenUniversalForm('', 'Не удалось отправить. Повторите попытку позже');
  }

  window.loaderHide('#basket-container');
};

const init = () => {
  const sendButtons = document.querySelectorAll('[data-basket-button="shareButton"]');

  sendButtons.forEach((elem) => {
    if (!elem.classList.contains('_share-init')) {
      elem.addEventListener('submit', shareButtonHandler);

      elem.classList.add('_share-init');
    }
  });
};

init();

window.initShareBasket = init;
